// src/config/clientConfig.js

const clientConfigs = {
    "goertrip.club": { pixelId: "934301932898251", name: "Client One" },
    "goertrip.club": { pixelId: "934301932898251", name: "Client Two" },
    "client3.com": { pixelId: "333333333333333", name: "Client Three" },
    "localhost": { pixelId: null, name: "Dev" }, // no pixel in dev
};

export function getClientConfig() {
    const hostname = window.location.hostname.replace("www.", "");
    return clientConfigs[hostname] || null;
}